var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-body" },
    [
      _c("b-breadcrumb", { attrs: { items: _vm.items } }),
      _c(
        "b-card",
        [
          _c("h3", [_c("span", [_vm._v(_vm._s(_vm.$t("lang.content.user")))])]),
          _c(
            "b-form",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: _vm.$t("lang.content.name"),
                            "label-for": "txtfirstName",
                          },
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "style2",
                            attrs: {
                              id: "txtfirstName",
                              type: "text",
                              placeholder: _vm.$t("lang.content.name"),
                              disabled: "",
                            },
                            model: {
                              value: _vm.user.firstName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.user,
                                  "firstName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "user.firstName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "input-group-2",
                            label: _vm.$t("lang.content.lastname"),
                            "label-for": "txtlastName",
                          },
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "style2",
                            attrs: {
                              id: "lastName",
                              type: "text",
                              placeholder: _vm.$t("lang.content.lastname"),
                              disabled: "",
                            },
                            model: {
                              value: _vm.user.lastName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.user,
                                  "lastName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "user.lastName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "input-group-3",
                            label: _vm.$t("lang.content.email"),
                            "label-for": "txtEmail",
                          },
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "style2",
                            attrs: {
                              id: "txtEmail",
                              placeholder: _vm.$t("lang.content.email"),
                              disabled: "",
                            },
                            model: {
                              value: _vm.user.email,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.user,
                                  "email",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "user.email",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-wrap justify-content-lg-end align-items-center btn-wrap pt-lg-5 pt-md-4 pt-2",
                },
                [
                  _c(
                    "b-button",
                    { attrs: { type: "button", to: "/usuarios" } },
                    [_vm._v(_vm._s(_vm.$t("lang.buttons.back")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }